import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import * as React from 'react';
import { MORE_ICON, VIP_SERVICE_ICON } from '@editor/src/img/pageIndex';

export const vipServiceConfig = {
    id: ActionType.VIP_CENTER,
    tipMsg: i18n.t('会员中心'),
    content: i18n.t('会员中心'),
    icon: VIP_SERVICE_ICON,
};

export const moreVipPrivilegesConfig = {
    id: ActionType.MORE_VIP_PRIVILEGES,
    tipMsg: i18n.t('更多特权'),
    content: i18n.t('更多特权'),
    icon: MORE_ICON,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: vipServiceConfig.id,
        icon: <img src={vipServiceConfig.icon} alt={''}/>,
        tooltip: vipServiceConfig.content,
        text: vipServiceConfig.content,
        respectOffline: true,
    },
    {
        name: moreVipPrivilegesConfig.id,
        icon: <img src={moreVipPrivilegesConfig.icon} alt={''}/>,
        tooltip: moreVipPrivilegesConfig.content,
        hasArrow: true,
        text: moreVipPrivilegesConfig.content,
        respectOffline: true,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: moreVipPrivilegesConfig.id,
        content: moreVipPrivilegesConfig.content,
    },
];

